@if (client?.civilId && client?.id) {

  <!-- ── Toolbar — outside the card ── -->
  <div class="mir__toolbar">
    <itfg-reports-info-panel
      [legacy]="false"
      [listData]="miListData"
      [reportData]="reportData"
      [reportTime]="requestTime"
      [requesterName]="reportData?.requesterName"
      [metaStatusCode]="''"
      [requestTime]="requestTime"
      [idCardNumber]="reportData?.data?.IdentityDocumentNumber"
      (dataChanged)="miDataChanged($event)">
    </itfg-reports-info-panel>

    <button mat-icon-button
            [disabled]="['MI_ADD'] | isUnauthorized | async"
            [matTooltip]="'mi.getNewMiReport' | translate"
            (click)="getNewMi()">
      <mat-icon color="primary">refresh</mat-icon>
    </button>
  </div>

  <!-- ── Card body ── -->
  <div class="mir">

    @if (miListData?.length === 0 && !isListData) {
      <p class="mir__empty">{{ 'mi.noMiFiles' | translate }}</p>
    }

    @if (reportData && reportData.status !== 'success') {
      <div class="mir__status-msg">
        <mat-icon class="mir__status-icon">info_outline</mat-icon>
        <span>{{ statusMessage }}</span>
        @if (reportData.status === 'server_timeout' || reportData.status === 'server_error') {
          <itfg-no-reports-info [alertMessage]="{
            civilId: client?.civilId,
            type: reportData?.type,
            source: reportData?.source,
            status: reportData?.status,
            time: reportData?.time,
            data: reportData?.data
          }"></itfg-no-reports-info>
        }
      </div>
    }

    @if (isReport && reportData?.data !== null) {
      <itfg-mi-card
        [isReport]="isReport"
        [civilId]="client?.civilId"
        [idCardNumber]="client?.idCardNumber"
        [reportData]="reportData"
        [clientReportData]="clientReportData">
      </itfg-mi-card>
    }

  </div>

} @else if (!client?.civilId && client?.id) {
  <p class="mir__no-civil-id">{{ 'credits.noCivilId' | translate }}</p>
}